document.addEventListener('DOMContentLoaded', function () {

  /** Sortiert Modelle im Container nach data-order und fügt optional Subheader ein */
  function sortModels(containerId) {
    var container = document.getElementById(containerId);
    if (!container) return;

    var models = Array.from(container.querySelectorAll('.nici-dd-model'));
    if (!models.length) return;

    models.sort(function (a, b) {
      var av = parseFloat(a.dataset.order || '0');
      var bv = parseFloat(b.dataset.order || '0');
      return av - bv;
    });

    // Neues Fragment aufbauen: optionalen Subheader (data-group-header) vor das jeweilige Element setzen
    var frag = document.createDocumentFragment();
    models.forEach(function (item) {
      var header = item.getAttribute('data-group-header');
      if (header) {
        var span = document.createElement('span');
        span.className = 'nici-dd-dropdown-subheader';
        span.textContent = header;
        frag.appendChild(span);
      }
      frag.appendChild(item);
    });

    container.innerHTML = '';
    container.appendChild(frag);
  }

  // Modelle sortieren + Subheader einfügen
  sortModels('nici-dd-iphone-models');
  sortModels('nici-dd-samsung-models');

  // Elemente greifen
  var dropdownRoot    = document.querySelector('.nici-dd-dropdown');
  var dropdownBtn     = document.getElementById('nici-dd-dropdown-btn');
  var dropdownContent = document.querySelector('.nici-dd-dropdown-content');
  var iphoneOption    = document.getElementById('nici-dd-iphone-option');
  var samsungOption   = document.getElementById('nici-dd-samsung-option');
  var iphoneModels    = document.getElementById('nici-dd-iphone-models');
  var samsungModels   = document.getElementById('nici-dd-samsung-models');

  // Hilfsfunktion: Liest bestehende Filter-Parameter aus der aktuellen URL
  function getCurrentFilterParams() {
    var urlParams = new URLSearchParams(window.location.search);
    var preservedParams = {};
    
    // Preserve the custom.hullen_kategorie filter
    for (var entry of urlParams.entries()) {
      var key = entry[0];
      var value = entry[1];
      if (key.includes('filter.p.m.custom.hullen_kategorie')) {
        preservedParams[key] = value;
      }
    }
    
    return preservedParams;
  }

  // Hilfsfunktion: Baut URL mit allen Filtern zusammen
  function buildUrlWithFilters(baseUrl, filterValue) {
    var url = new URL(baseUrl, window.location.origin);
    var preservedParams = getCurrentFilterParams();
    
    // Add preserved filters
    for (var key in preservedParams) {
      if (preservedParams.hasOwnProperty(key)) {
        url.searchParams.set(key, preservedParams[key]);
      }
    }
    
    // Add the model filter
    if (filterValue) {
      var modelValue = filterValue.replace('filter.v.option.modell=', '');
      // Normalize: replace + with spaces so URLSearchParams encodes them correctly as +
      var normalized = modelValue.replace(/\+/g, ' ');
      url.searchParams.set('filter.v.option.modell', normalized);
    }
    
    return url.toString();
  }

  // Dropdown öffnen/schließen mit Toggle-Funktion
  function setOpen(isOpen) {
    if (!dropdownRoot || !dropdownContent) return;
    dropdownRoot.classList.toggle('is-open', isOpen);
    dropdownContent.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    dropdownContent.style.display = isOpen ? 'block' : 'none';
  }

  if (dropdownBtn && dropdownContent) {
    dropdownBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = dropdownRoot && dropdownRoot.classList.contains('is-open');
      setOpen(!isOpen);
    });

    // Klick außerhalb schließt Dropdown
    document.addEventListener('click', function (e) {
      if (dropdownRoot && !dropdownRoot.contains(e.target)) {
        setOpen(false);
      }
    });
  }

  // Tabs umschalten
  function activate(tab) {
    if (!iphoneOption || !samsungOption || !iphoneModels || !samsungModels) return;
    var iphone = tab === 'iphone';
    iphoneOption.classList.toggle('active', iphone);
    samsungOption.classList.toggle('active', !iphone);
    iphoneModels.style.display  = iphone ? 'block' : 'none';
    samsungModels.style.display = iphone ? 'none'  : 'block';
  }
  iphoneOption  && iphoneOption.addEventListener('click', function(){ activate('iphone'); });
  samsungOption && samsungOption.addEventListener('click', function(){ activate('samsung'); });

  // Klick auf ein Modell (Delegation auf die Container)
  function onModelClick(e) {
    var link = e.target.closest('.nici-dd-model');
    if (!link) return;

    e.preventDefault();
    var selectedModel = (link.textContent || '').trim();
    var filterValue   = link.getAttribute('data-filter-value');
    var collectionUrl = link.getAttribute('href') || '#';

    if (dropdownBtn) dropdownBtn.textContent = selectedModel;
    setOpen(false);

    // Neue URL mit allen Filtern aufbauen
    var newUrl = buildUrlWithFilters(collectionUrl, filterValue);
    window.location.href = newUrl;
  }
  iphoneModels  && iphoneModels.addEventListener('click', onModelClick);
  samsungModels && samsungModels.addEventListener('click', onModelClick);

  /* ---------- FALLBACK-SELECT (ohne jQuery) ---------- */
  var select = document.getElementById('phone_cases_models');
  if (select) {
    select.addEventListener('change', function(){
      var opt = select.options[select.selectedIndex];
      var url = select.value;
      var filter = opt && opt.getAttribute('data-filter-value');
      
      // Neue URL mit allen Filtern aufbauen
      var newUrl = buildUrlWithFilters(url, filter);
      window.location.href = newUrl;
    });

    // Auto-Filter nur wenn data-autofilter="true"
    var shouldAuto = (select.dataset.autofilter || '').toLowerCase() === 'true';
    if (shouldAuto) {
      var params = new URLSearchParams(window.location.search);
      if (!params.get('filter.v.option.modell')) {
        var sel = select.options[select.selectedIndex];
        var f = sel && sel.getAttribute('data-filter-value');
        if (f) {
          var newUrl = buildUrlWithFilters(window.location.pathname, f);
          window.location.href = newUrl;
        }
      }
    }

    // Sortieren nach data-order
    var opts = Array.from(select.querySelectorAll('option'));
    opts.sort(function(a,b){ return (+a.dataset.order || 0) - (+b.dataset.order || 0); });
    select.innerHTML = '';
    opts.forEach(function(o){ select.appendChild(o); });
  }
});
